import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../RootState';

export const selectDataSuggested = createSelector(
    (state: RootState) => state.shopping_cart,
    (suggested) => suggested
);

export const selectCommercialCartSelection = createSelector(
    (state: RootState) => state.shopping_cart.suggested.selection,
    (selection) => selection
);

export const selectSelectedMonths = createSelector(
    (state: RootState) => state.shopping_cart.suggested.selection.selectedMonths,
    (selectedMonths) => selectedMonths
);

export const selectSelectedPaymentMethod = createSelector(
    (state: RootState) => state.shopping_cart.suggested.selection.selectedPaymentMethod,
    (selectedPaymentMethod) => selectedPaymentMethod
);

export const selectHasInputErrors = createSelector(
    (state: RootState) => state.shopping_cart.suggested.selection.inputErrorByProductId,
    (inputErrorByProductId) =>
        Object.values(inputErrorByProductId).some((e) => e.price || e.quantity)
);